class CookieBannerComponent extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'ob_consent_state';
    this.coreCategories = ['strictly_necessary', 'functional', 'analytics', 'marketing', 'customer_service'];
    this.gpcActive = false;
  }

  connectedCallback() {
    window.otterConsent = window.otterConsent || {};
        window.otterConsent.triggerUpdate = function(state) {
            if (typeof window.otterConsent.onUpdate === 'function') {
                window.otterConsent.onUpdate(state);
            }
        };
    this.isDebug = this.dataset.debugMode === 'true';
    this.forceShow = this.dataset.forceShow === 'true';
    this.profile = this.dataset.tealiumProfile || 'NA';
    this.consentVersion = this.dataset.consentVersion || '1.0';
    this.cookieExpirationDays = parseInt(this.dataset.cookieExpiration, 10) || 180;
    this.market = this.dataset.market;
    
    this.shield = this.querySelector('[data-cookie-shield]');
    this.modal = this.querySelector('#custom-preferences-modal');
    this.preferencesForm = this.querySelector('#cookie-preferences-form');
  

    this.initDefaultState();
    this.setupEventListeners();
    this.initializeConsent();
    this.handleURLParameters();
  }

  handleURLParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.get('do_not_sell') === 'true') {
      this.handleDoNotSell();
    } else if (urlParams.get('manage_privacy') === 'true') {
      this.openPreferencesModal();
    }
  }

  initDefaultState() {
    const state = { strictly_necessary: true };
    const inputs = this.querySelectorAll('input[data-category-key]');

    inputs.forEach(input => {
      const key = input.dataset.categoryKey;
      if (key === 'strictly_necessary') return;
      state[key] = (input.dataset.defaultState === 'true');
    });
    
    this.coreCategories.forEach(category => {
      if (state[category] === undefined) state[category] = false; 
    });
    
    this.defaultState = state;
  }

async initializeConsent() {
  if (this.checkDebugOverrides()) return;

  const currentState = this.getConsentCookie();
  const isVersionMatch = currentState && currentState.version === this.consentVersion;
  const isProfileMatch = currentState && currentState.profile === this.profile;
  const isMarketMatch = currentState && currentState.market === this.market;

  if (!currentState || !isVersionMatch || !isProfileMatch || !isMarketMatch) {
    const isGpcActive = navigator.globalPrivacyControl === true || window.otterConsent?.isGpcActive;
    
    if (isGpcActive) {
      this.gpcActive = true;
      const gpcOptOutState = {
        strictly_necessary: true,
        functional: false,
        analytics: false,
        marketing: false,
        customer_service: false
      };
      this.setConsentCookie(gpcOptOutState);
      this.showBanner();
      this.setAttribute('data-gpc-active', 'true');
      return;
    }
    
    this.showBanner();
  } else {
    this.hideBanner();
    if (window.otterConsent && typeof window.otterConsent.triggerUpdate === 'function') {
      window.otterConsent.triggerUpdate(currentState);
    }
  }
}

  checkDebugOverrides() {
    const urlParams = new URLSearchParams(window.location.search);
    if (this.forceShow || urlParams.get('debug_privacy') === 'true') {
      this.showBanner();
      return true;
    }
    return false;
  }

  setupEventListeners() {
    this.querySelector('[data-cookie-accept]')?.addEventListener('click', () => this.handleFullConsent(true));
    this.querySelector('[data-cookie-accept-necessary]')?.addEventListener('click', () => this.handleFullConsent(false));
    this.querySelector('[data-cookie-manage]')?.addEventListener('click', () => this.openPreferencesModal());
    this.querySelector('[data-cookie-privacy-settings]')?.addEventListener('click', () => this.openPreferencesModal());
    this.querySelector('[data-cookie-back]')?.addEventListener('click', () => this.handleBack());
    this.querySelector('[data-cookie-save-preferences]')?.addEventListener('click', () => this.handleSavePreferences());
    this.querySelector('[data-cookie-do-not-sell]')?.addEventListener('click', () => this.handleDoNotSell());
    document.addEventListener('click', (e) => {
      const menuTrigger = e.target.closest('a');
      if (menuTrigger) {
        if (menuTrigger.hash === '#manage-cookie-preferences') {
          e.preventDefault();
          this.openPreferencesModal();
        }
        if (menuTrigger.hash === '#do-not-sell') {
          e.preventDefault();
          this.handleDoNotSell();
        }
      }
    });
  }

  handleFullConsent(isAll) {
  if (this.gpcActive) {
    this.hideBanner();
    return;
  }

  const newState = { ...this.defaultState };

  Object.keys(newState).forEach(key => {
    if (key === 'strictly_necessary') return;
    if (isAll) {
      newState[key] = true;
    } else {
      newState[key] = false;
    }
  });
  this.processConsentUpdate(newState, 'full_consent');
}

  handleDoNotSell() {
    const currentState = this.getConsentCookie() || { ...this.defaultState };
    const newState = {
      ...currentState,
      marketing: false,
      analytics: false
    };
    this.processConsentUpdate(newState, 'do_not_sell_opt_out', true);
    if (this.modal.classList.contains('is-open')) {
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
    }
  }

  openPreferencesModal() {
  this.hideBanner(false);
  
  if (this.gpcActive) {
    this.preferencesForm.classList.add('gpc-mode');
    
    const existingMsg = this.preferencesForm.querySelector('.gpc-locked-message');
    if (existingMsg) existingMsg.remove();
    
    const gpcMsg = document.createElement('div');
    gpcMsg.className = 'gpc-locked-message';
    gpcMsg.innerHTML = 'Your Global Privacy Control preference is active. Cookie settings are locked to respect your privacy choice.';
    this.preferencesForm.insertBefore(gpcMsg, this.preferencesForm.firstChild);
  }
  
  const currentState = this.getConsentCookie() || this.defaultState;
  this.preferencesForm.querySelectorAll('input[data-category-key]').forEach(input => {
    const key = input.dataset.categoryKey;
    if (key === 'strictly_necessary') return;
    
    if (this.gpcActive) {
      input.disabled = true;
      input.checked = false;
      input.setAttribute('aria-disabled', 'true');
    } else {
      input.disabled = false;
      input.setAttribute('aria-disabled', 'false');
      input.checked = currentState[key] !== undefined ? currentState[key] : (input.dataset.defaultState === 'true');
    }
  });
  
  this.modal.classList.add('is-open');
  this.modal.setAttribute('aria-hidden', 'false');
}

  handleBack() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    this.showBanner();
  }

  handleSavePreferences() {
    const newState = { strictly_necessary: true };
    const inputs = this.preferencesForm.querySelectorAll('input[data-category-key]');

    inputs.forEach(input => {
      const key = input.dataset.categoryKey;
      if (key === 'strictly_necessary') return;
      newState[key] = input.checked;
    });
    
    this.coreCategories.forEach(key => {
        if (newState[key] === undefined) newState[key] = false;
    });

    this.processConsentUpdate(newState, 'preferences_saved', true);
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
  }

  processConsentUpdate(state, context, showToast = false) {
    this.setConsentCookie(state);
    this.hideBanner();
    if (window.otterConsent && typeof window.otterConsent.triggerUpdate === 'function') {
      window.otterConsent.triggerUpdate(state);
    }
    if (showToast) {
      const toast = this.querySelector('.cookie-toast');
      if (toast) {
        toast.classList.add('is-visible');
        setTimeout(() => toast.classList.remove('is-visible'), 3000);
      }
    }
  }

  showBanner() {
    this.classList.add('cookie-banner--visible');
    this.setAttribute('aria-hidden', 'false');
    if (this.shield && this.dataset.blockClicks === 'true') {
      this.shield.style.display = 'block';
    }
  }

  hideBanner(hideShield = true) {
    if (this.contains(document.activeElement)) document.activeElement.blur();
    this.classList.remove('cookie-banner--visible');
    this.setAttribute('aria-hidden', 'true');
    if (hideShield && this.shield) this.shield.style.display = 'none';
  }

  getConsentCookie() {
    const match = document.cookie.match(new RegExp('(^| )' + this.cookieName + '=([^;]+)'));
    return match ? JSON.parse(decodeURIComponent(match[2])) : null;
  }

  setConsentCookie(state) {
    state.version = this.consentVersion;
    state.profile = this.profile;
    state.market = this.market;
    const domain = window.location.hostname.replace('www.', '');
    const maxAgeInSeconds = this.cookieExpirationDays * 24 * 60 * 60;
    document.cookie = `${this.cookieName}=${encodeURIComponent(JSON.stringify(state))}; domain=${domain}; Max-Age=${maxAgeInSeconds}; path=/; SameSite=Lax; Secure`;
  }
}

customElements.define('cookie-banner-component', CookieBannerComponent);